import baseV3Service from './base/baseV3Service.js';

const getProspectsIntelligence = (config) => {
    return baseV3Service.get("pi", config);
};
const getProspectsActivities = (config) => {
    return baseV3Service.get(`pi/activities`, config);
};
const getProspectActivities = (id, config) => {
    return baseV3Service.get(`pi/${id}/activities`, config);
};
const getProspectActivityDetails = (id, config) => {
    return baseV3Service.get(`pi/activities/${id}`, config);
};
const getProspectRoomViews = (id, config) => {
    return baseV3Service.get(`pi/${id}/rooms-viewed`, config);
};
const getProspectTotalSessions = (id, config) => {
    return baseV3Service.get(`pi/${id}/total-sessions`, config);
};
const getProspectTotalEngagement = (id, config) => {
    return baseV3Service.get(`pi/${id}/total-engagement`, config);
};
const getProspectTotalSpacesViews = (id, config) => {
    return baseV3Service.get(`pi/${id}/total-spaces`, config);
};
const getProspectIdealBedrooms = (id, config) => {
    return baseV3Service.get(`pi/${id}/ideal-bedrooms`, config);
};
const getProspectIdealPrices = (id, config) => {
    return baseV3Service.get(`pi/${id}/ideal-prices`, config);
};
const getProspectIdealFloorPlans = (id, config) => {
    return baseV3Service.get(`pi/${id}/ideal-floor-plans`, config);
};
const getProspectIntelligenceScore = (id, config) => {
    return baseV3Service.get(`pi/${id}/score`, config);
};

export { getProspectActivities, getProspectActivityDetails, getProspectIdealBedrooms, getProspectIdealFloorPlans, getProspectIdealPrices, getProspectIntelligenceScore, getProspectRoomViews, getProspectTotalEngagement, getProspectTotalSessions, getProspectTotalSpacesViews, getProspectsActivities, getProspectsIntelligence };
